export const ORG_ROLES = ["ORG_ADMIN"] as const;
export type OrgRole = (typeof ORG_ROLES)[number];

export const PROPERTY_ROLES = ["PROPERTY_ADMIN"] as const;
export type PropertyRole = (typeof PROPERTY_ROLES)[number];

/** What an invitation grants. PLATFORM = superadmin; OWNER / TENANT = portál-hozzáférés. */
export const INVITATION_SCOPES = ["PLATFORM", "ORG", "PROPERTY", "OWNER", "TENANT"] as const;
export type InvitationScope = (typeof INVITATION_SCOPES)[number];

export const MAILBOX_PURPOSES = ["INVITATION", "INVOICE", "REMINDER", "GENERAL"] as const;
export type MailboxPurpose = (typeof MAILBOX_PURPOSES)[number];

/** Egy fiók pontosan egyféle (docs/portalok.md 2.1). */
export const ACCOUNT_TYPES = ["STAFF", "OWNER", "TENANT"] as const;
export type AccountType = (typeof ACCOUNT_TYPES)[number];
export const ACCOUNT_TYPE_LABEL: Record<AccountType, string> = { STAFF: "munkatárs", OWNER: "tulajdonosi", TENANT: "bérlői" };

/** Where a user lands right after login (see GET /api/me/landing). */
export type Landing =
  | { kind: "orgs" }
  | { kind: "properties"; orgSlug: string }
  | { kind: "property"; orgSlug: string; propertyId: string }
  | { kind: "portal"; as: "OWNER" | "TENANT" }
  | { kind: "empty" };
